// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"AppRouter_mainContainer__3TBm0","contentContainer":"AppRouter_contentContainer__3Vprh"};